enum Role {
  NonProfessional,
  OrgNonProfessional,
  Professional,
  OrgProfessional,
  OrgAdmin,
  Reviewer,
  Consultant
}

export default Role;
